/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { Link } from "react-router-dom";
import { ReactComponent as ServicesIcon } from "cms/assets/icons/square-grid.svg";
import { ReactComponent as NotificationIcon } from "cms/assets/icons/bell.svg";
import { ReactComponent as AccountIcon } from "cms/assets/icons/account.svg";
import { AuthCustomerGuard } from "cms/auth-customer/auth-customer-guard";
import { NotAuthCustomerGuard } from "cms/auth-customer/notauth-customer-guard";
import { CircularProgress } from "@mui/material";
import { useCustomerAuth } from "cms/auth-customer/use-customer-auth";
import { ReactComponent as LoginIcon } from "cms/assets/icons/login.svg";

const AccountButtons = () => {

    const { processing, login, logout } = useCustomerAuth();

    return (
        <div className='account-buttons-auth'>
            <AuthCustomerGuard>
                <Link to='/services' className='your-services-link services-nav-button'>
                    <ServicesIcon alt='services-icon' />
                    Your services
                </Link>
                {!processing &&
                    <div className='account-notification-buttons'>
                        <Link to='#' className='icon-link'>
                            <NotificationIcon alt='notification-icon' />
                        </Link>
                        <Link
                            to='#'
                            className='icon-link'
                            onClick={logout}
                        >
                            <AccountIcon alt='account-icon' />
                        </Link>
                    </div>
                }
                {processing &&
                    <CircularProgress
                        style={{ height: "34px", width: "34px", color: "white" }}
                        color="primary"
                    />
                }
            </AuthCustomerGuard>

            <NotAuthCustomerGuard>
                <Link
                    style={{ height: "42px", display: "flex", justifyContent: "center", alignItems: "center" }}
                    to='#'
                    className='your-services-link services-nav-button'
                    onClick={login}
                >
                    {!processing &&
                        <>
                            Login to your services
                            <LoginIcon alt='login-icon' />
                        </>
                    }
                    {processing &&
                        <CircularProgress
                            style={{ height: "34px", width: "34px", color: "white" }}
                            color="primary"
                        />
                    }
                </Link>
            </NotAuthCustomerGuard>
        </div>
    );
};

export { AccountButtons };
